// extracted by mini-css-extract-plugin
export default {"cls1":"tNaL1pluPlSUKg8GQkek","cls2":"YprNp76jXZ8WkP6kbfHh tNaL1pluPlSUKg8GQkek"};